import Card from '@mui/material/Card';
import styled from 'styled-components';

const StyledCard = styled(Card)`
	padding: 24px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
`;

export {StyledCard};
